import { createSelector } from 'reselect';
import EdiExchangeLetterColumns from '../../containers/EdiExchangeLetterColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

const getMetadata = state => state.reporting.EDI_EXCHANGE_LETTER_706.metadata;
export const getGeneratedOnDateTime = state => getMetadata(state).generatedOnDateTime;
export const getIsLoading = state => state.reporting.EDI_EXCHANGE_LETTER_706.isLoading;
export const getData = ReportDefinitions.EDI_EXCHANGE_LETTER_706.getDataFunction();
export const getColumns = createSelector(getData, getMetadata, EdiExchangeLetterColumns);
